/**
 * Supabase client for ScanIFHurt (PostgreSQL).
 * Supabase is required for this app; Firebase will be removed after migration.
 *
 * Env (required – use one set):
 *   Development: REACT_APP_SUPABASE_DEV_API_URL + REACT_APP_SUPABASE_DEV_ANON_KEY
 *   Or:         REACT_APP_SUPABASE_URL + REACT_APP_SUPABASE_ANON_KEY
 * Get URL and anon key from Supabase Dashboard → Project Settings → API.
 * If using a custom proxy URL: it must allow CORS from your app origin (e.g. http://localhost:3000).
 * For local dev, the direct Supabase URL (https://PROJECT_REF.supabase.co) avoids proxy CORS.
 */
import { createClient } from '@supabase/supabase-js';

const isDev = process.env.NODE_ENV === 'development';
const supabaseUrl = process.env.REACT_APP_SUPABASE_DEV_API_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_DEV_ANON_KEY;

const hasConfig = Boolean(supabaseUrl && supabaseAnonKey);

export const supabase = hasConfig
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
      },
    })
  : null;

export const supabaseConfigMissing = !hasConfig;
